import { Link as LinkLi } from '@material-ui/core';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasValue } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { Link as LinkDom } from 'react-router-dom';
import { columns } from './config';
import Form from './Form';
import RoadsideInspections from './RoadsideInspections';
import Trailers from './Trailers';

const layout = window?.$environment?.CURRENT_LAYOUT;
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <>
      <Component {...contentProps} filters={filters} />
    </>
  );
};
export default Index;

const Component = ({
  history,
  vehicles,
  apiStatus,
  fetchVehicles,
  handleDeleteAlert,
  callback,
  fetchVehiclePageHistoryMap,
  vehiclePageMap,
  openDocument,
  getDrivers,
  Styled,
  i18n,
  handleTrailerDeleteAlert,
  pagination,
  setPagination,
}) => {
  const [openModalRefEmptyData, setModalRefEmptyData] = useState(false);
  const [driverIdSuggestion, setDriverIdSuggestion] = useState([]);
  const [openModalRef2, setModalRef2] = useState(false);
  const [openModalDriverName, setModalDriverName] = useState(false);

  useEffect(() => {
    if (vehicles.vehicleList.length) driverArray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles]);

  useEffect(() => {
    if (vehiclePageMap.type === 'vehicleHistoryMap' && vehiclePageMap.data && vehiclePageMap.data.length === 0) {
      clickedModalEmptyData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehiclePageMap]);

  const driverArray = () => {
    let driverIdSuggestion = vehicles.vehicleList.map((items) => ({
      label: items.unit_id,
      value: items.id,
    }));
    setDriverIdSuggestion(driverIdSuggestion);
  };

  const closeModalDelete = () => {
    setModalRef2(false);
  };
  const clickedModalDelete = () => {
    setModalRef2(true);
  };

  const closeModalEmptyData = () => {
    setModalRefEmptyData(false);
  };
  const clickedModalEmptyData = () => {
    setModalRefEmptyData(true);
  };

  const [ModalListObject2, setModalListObject2] = useState({
    header: '',
    content: () => {},
  });

  const [ModalDriverNameData, setModalDriverNameData] = useState({
    header: '',
    content: () => {
      return <> </>;
    },
  });

  const generateRows = () => {
    const updatedList = vehicles.vehicleFilteredList.map((item, index) => {
      item.driversList = (
        <div className="driverNamePopup" onClick={() => openDriverNamePopup(item.drivers, item.unit_id)}>
          {item.driversCount}
        </div>
      );
      return item;
    });
    return updatedList;
  };

  const openDriverNamePopup = (drivers, unit_id) => {
    getDrivers({
      apiId: 'getDriversVehiclePage',
      data: {
        driverIds: drivers,
      },
      callback: openDriverNamePopupModal,
      unit_id: unit_id,
    });
  };

  const openDriverNamePopupModal = (type, res, req) => {
    let str = res?.response;
    let str_array = str.split(',');
    let array = [];
    for (var i = 0; i < str_array.length; i++) {
      array.push(str_array[i]);
    }
    setModalDriverName(true);
    return setModalDriverNameData({
      content: () => {
        return (
          <div className="driverNameModal">
            <div className="headWrapper">
              {i18n.t('DRIVERS OF')} {req?.unit_id}
            </div>
            <ul>
              {array.map((items, index) => {
                return <li key={index}>{items}</li>;
              })}
            </ul>
          </div>
        );
      },
    });
  };
  const hasUserListApiStatus = hasValue(apiStatus.status, 'api', fetchVehicles);
  const information =
    hasUserListApiStatus && hasUserListApiStatus.errorMessage ? (
      <Message type="error" message={i18n.t(hasUserListApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  return (
    <>
      <Styled.Wrapper>
        <Styled.MiddleWrapper>
          <div className="mapContainer">
            <Styled.MapWrapper>
              <GoogleMap type={vehiclePageMap.type} height={'700px'} data={vehiclePageMap} />
            </Styled.MapWrapper>
            <Styled.TrackWrapper>
              <div className="trackVehicleForm">
                <Form
                  apiStatus={apiStatus}
                  fetchVehiclePageHistoryMap={fetchVehiclePageHistoryMap}
                  history={history}
                  vehicles={vehicles}
                  driverIdSuggestion={driverIdSuggestion}
                  Styled={Styled}
                />
              </div>
            </Styled.TrackWrapper>
          </div>
          <Styled.TableWrapper>
            <SubHeader
              className="subheaderSection userHeading vehicleTable"
              text={i18n.t('vehicles.tabs.listVehicles')}
              variant="h2"
            />
            <div className="vehicleTable">
              <Table
                type="client"
                defaultSortBy={{ sortBy: 'unit_id', order: 'asc' }}
                title=""
                columns={[...columns]}
                data={generateRows()}
                emptyMessage={information}
                itemsPerPage={10}
                actions={[
                  {
                    icon: (row) => {
                      return (
                        <LinkLi
                          component={LinkDom}
                          to={pageUrls.editVehicle.replace(':id', row.id)}
                          onClick={() => {}}
                          className="normalLink"
                          key={row.id + 'link'}
                        >
                          <Icon src={mediaUrls?.edit} />
                        </LinkLi>
                      );
                    },
                  },
                  {
                    icon: (row) => {
                      return (
                        <Icon
                          key={row.id + 'icon'}
                          src={mediaUrls?.deleteIcon}
                          onClick={() => {
                            setModalListObject2({
                              content: () => (
                                <div className="deleteParent">
                                  <div className="imageSection">
                                    <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                                  </div>
                                  <h2> {i18n.t('common.sureConfirm')} </h2>
                                  <p> {i18n.t('common.recoverConfirm')}</p>
                                  <div className="deletePopupBtn">
                                    <div className="cancelBtn">
                                      <Button
                                        label={i18n.t('Cancel')}
                                        type={'reset'}
                                        onClick={() => {
                                          closeModalDelete();
                                        }}
                                      ></Button>
                                    </div>
                                    <div className="deletebtn">
                                      <Button
                                        label={i18n.t('common.deletePopup')}
                                        onClick={() => {
                                          handleDeleteAlert({
                                            id: 'deleteAlert',
                                            data: { id: row.id },
                                            callback: callback,
                                          });
                                          closeModalDelete();
                                        }}
                                      ></Button>
                                    </div>
                                  </div>
                                </div>
                              ),
                            });
                            clickedModalDelete();
                          }}
                        />
                      );
                    },
                  },
                ]}
                defaultSort={'full_name'}
                i18n={i18n}
                pageinationReset={pagination}
                pagenationClicked={(e) => {
                  setPagination(!e);
                }}
              />
            </div>
          </Styled.TableWrapper>
        </Styled.MiddleWrapper>

        <Styled.BottomWrapper>
          <div className="vehicleLists">
            <p className="title">{i18n.t('vehicles.tabs.roadInspection')}</p>
            <RoadsideInspections history={history} openDocument={openDocument} i18n={i18n} />
          </div>
          <div className="vehicleLists">
            <p className="title">{i18n.t('vehicles.tabs.listTrailers')}</p>
            <Trailers
              history={history}
              callback={callback}
              trailers={vehicles?.trailerFilteredList}
              apiStatus={apiStatus}
              handleDeleteAlert={handleTrailerDeleteAlert}
            />
          </div>
        </Styled.BottomWrapper>
      </Styled.Wrapper>

      <Modal open={openModalRef2} setOpen={setModalRef2} data={ModalListObject2} deletePopup />

      <Modal
        open={openModalRefEmptyData}
        setOpen={setModalRefEmptyData}
        data={{
          header: '',
          content: () => (
            <div className="deleteParent">
              <div className="imageSection">
                <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
              </div>
              <h2> {i18n.t('common.noBreadcrumbData')} </h2>
              <div className="deletePopupBtn">
                <div className="deletebtn">
                  <Button
                    label={i18n.t('common.ok')}
                    type={'submit'}
                    onClick={() => {
                      closeModalEmptyData();
                    }}
                  ></Button>
                </div>
              </div>
            </div>
          ),
        }}
        deletePopup
        width={'450px'}
      />
      <Modal
        open={openModalDriverName}
        setOpen={setModalDriverName}
        data={ModalDriverNameData}
        deletePopup
        withCloseIcon
        alignItemsLeft
        width={'260px'}
      />
    </>
  );
};

Component.propTypes = {
  callback: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  fetchVehicles: PropTypes.func.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  handleExportVehicle: PropTypes.func.isRequired,
  handleImportVehicle: PropTypes.func.isRequired,
  handleImportTrailer: PropTypes.func.isRequired,
  handleImportVehiclePost: PropTypes.func.isRequired,
  handleImportTrailerPost: PropTypes.func.isRequired,
  fetchVehiclePageMap: PropTypes.func.isRequired,
  fetchVehiclePageHistoryMap: PropTypes.func.isRequired,
  vehiclePageMap: PropTypes.func.isRequired,
};
